// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"88fb6843","488":"30d8dbb5","977":"0d3fb9f5"}[chunkId] + ".chunk.js";
};